import { useEffect, useRef, useState } from "react";
import { useReducedMotion } from "framer-motion";

/** Animate only visible elements in a foreground tab. */
export function useVisibleMotion<T extends Element>() {
  const ref = useRef<T>(null);
  const reducedMotion = useReducedMotion();
  const [active, setActive] = useState(false);

  useEffect(() => {
    let visible = false;
    const update = () => setActive(visible && !reducedMotion && document.visibilityState === "visible");
    const observer = new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      update();
    });
    if (ref.current) observer.observe(ref.current);
    document.addEventListener("visibilitychange", update);
    return () => {
      observer.disconnect();
      document.removeEventListener("visibilitychange", update);
    };
  }, [reducedMotion]);

  return { ref, active };
}